export  class RoomSchedulingSettingsPreferences {
    AvailableColumns: string[] = [];
    ShowColumns: string[] = [];
}
